exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".code-space {\n  width: 100%;\n  height: 500px;\n  background-color: #a9a9a905;\n  padding: 25px;\n  border-radius: 5px;\n  border: 1px solid rgba(0, 0, 0, 0.15); }\n\ntextarea:focus {\n  border: 1px solid rgba(0, 0, 0, 0.15) !important;\n  border-color: 1px solid rgba(0, 0, 0, 0.15) !important; }\n", ""]);

// exports
